var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    fillRule: "evenodd",
    d: "M48.6131717,13.7447145 L48.6647315,13.7879784 C50.0514728,14.9515925 50.2323532,17.0190641 49.068739,18.4058054 L36.822,33 L49.068739,47.5941946 C50.1907955,48.9314094 50.0626779,50.9015993 48.8086904,52.0839623 L48.6647315,52.2120216 L48.6131717,52.2552855 C47.2264304,53.4188996 45.1589588,53.2380193 43.9953447,51.851278 L32.499,38.151 L21.0046553,51.851278 C19.8410412,53.2380193 17.7735696,53.4188996 16.3868283,52.2552855 L16.3352685,52.2120216 C14.9485272,51.0484075 14.7676468,48.9809359 15.931261,47.5941946 L28.177,33 L15.931261,18.4058054 C14.8092045,17.0685906 14.9373221,15.0984007 16.1913096,13.9160377 L16.3352685,13.7879784 L16.3868283,13.7447145 C17.7735696,12.5811004 19.8410412,12.7619807 21.0046553,14.148722 L32.5,27.848 L43.9953447,14.148722 C45.1589588,12.7619807 47.2264304,12.5811004 48.6131717,13.7447145 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.a3103bb930eb8b445b397ac6f02041d1.svg";
export { ForwardRef as ReactComponent };